import { render } from "./ValidationFirstDMV.vue?vue&type=template&id=13ba5d86"
import script from "./ValidationFirstDMV.vue?vue&type=script&lang=js"
export * from "./ValidationFirstDMV.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__